module.exports = __webpack_public_path__ + "img/menu.7e480e03.svg";